import { render, staticRenderFns } from "./GradeComparison.vue?vue&type=template&id=328e7659&scoped=true&"
import script from "./GradeComparison.vue?vue&type=script&lang=js&"
export * from "./GradeComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e7659",
  null
  
)

export default component.exports